const getSyncedEnergyMotionRecordSource = (source: string | undefined): string => {
  if (source?.startsWith('google-health-connect')) {
    return 'google-health-connect'
  }

  if (source?.startsWith('apple-health-kit')) {
    return 'apple-health-kit'
  }

  return 'none'
}

export default getSyncedEnergyMotionRecordSource
